import { z } from "zod";

import { patientImageAnalysisResultSchema } from "@/src/models/patient-image-analysis";

export { PatientImageCategory as SmsMediaCategory } from "@/src/models/patient-image-analysis";

export const smsMediaFactSchema = patientImageAnalysisResultSchema.shape.attachments.element.shape.facts.element;

export const smsMediaAnalysisResultSchema = patientImageAnalysisResultSchema;

export const smsMediaAnalysisSchema = patientImageAnalysisResultSchema.shape.attachments.element.extend({
  analyzedAt: z.string(),
  contentType: z.string(),
  insurance: patientImageAnalysisResultSchema.shape.attachments.element.shape.insurance.optional(),
  model: z.string(),
});

export type SmsMediaAnalysis = z.infer<typeof smsMediaAnalysisSchema>;
export type SmsMediaAnalysisResult = z.infer<typeof smsMediaAnalysisResultSchema>;
